<template>
    <div class="w-full min-w-[200px]">
        <label v-if="label" class="block mb-1 text-sm text-slate-800">
            {{ label }}
        </label>
        <div class="relative">
            <select
                v-bind="attributes" @change="onChange($event)"
                class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-3 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 appearance-none cursor-pointer">
                <option
                    value=""
                    disabled
                    hidden
                    :selected="!modelValue"
                    class="text-slate-400">
                    {{ placeholder }}
                </option>
                <option
                    :selected="isCurrentValue(item)"
                    v-for="item in _options"
                    :key="item.value || item"
                    :value="item.value">
                    {{ item.label ?? item.value ?? item }}
                </option>
            </select>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor" class="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
            </svg>
        </div>

        <p v-if="helperKey && !!currentOption[helperKey]" class="flex items-center mt-2 text-xs text-slate-500">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-5 h-5 mr-2"
            >
                <path
                    fill-rule="evenodd"
                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                    clip-rule="evenodd"
                ></path>
            </svg>
            {{ currentOption[helperKey] }}
        </p>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { Select, initTE } from "tw-elements"

/**
 * @description
 */
export default defineComponent({
    name: 'SelectWrapper',

    data: () => ({
        currentOption: {}
    }),

    props: {
        modelValue: [String,Number,Object],
        outline: Boolean,
        options: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: ''
        },
        label: '',
        helperKey: ''
    },

    computed: {
        _options: vm => {
            if (typeof vm.options[0] === 'object') {
                return vm.options
            }
            return vm.options.map(el => ({ label: el, value: el, info: '' }))
        },
        attributes: vm => {
            const result = {}
            return result
        },
        isCurrentValue: vm => value => {
            if (value && typeof value === 'object') {
                return value.value === vm.modelValue
            }
            return value === vm.modelValue
        }
    },

    mounted () {
        initTE({ Select }, { allowReinits: true })
        if (this.modelValue) {
            this.currentOption = this._options.find(el => {
                if (el && typeof el === 'object') {
                    return el.value === this.modelValue
                }
                return el === this.modelValue
            }) || {}
        }
    },

    watch: {
        modelValue(newVal) {
            if (newVal) {
                this.currentOption = this._options.find(el => {
                    if (el && typeof el === 'object') {
                        return el.value === newVal
                    }
                    return el === newVal
                }) || {}
            } else {
                this.currentOption = {}
            }
        }
    },

    methods: {
        onChange (event) {
            const value = event.target.value
            this.currentOption = this._options.find(el => {
                if (el && typeof el === 'object') {
                    return el.value === value
                }
                return el === value
            }) || {}
            this.$emit('update:modelValue', value)
        }
    }
})
</script>

<style lang="scss">
</style>